import './App.css';
import './styles/v2.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/navbar/index.jsx';
import Footer from './components/Footer/Footer.js';
import ScrollToTop from './components/ScrollToTop';

// AQTLanding pages
import MainPage from './pages/MainPage/MainBody.js';
import RaiseFunding from './pages/RaiseFunding/RaiseFunding.js';
import Blog from './pages/Blog/Blog.js';
import Unlisted from './pages/Unlisted/index.jsx';
import SellIPOShares from './pages/SellIPOShares/SellIPOShares.js';
import MediaCoverage from './pages/MediaCoverage/MediaCoverage.js';
import ContactUs from './pages/ContactUs/Contact.js';
import Polymatech from './pages/Polymatech/Polymatech.js';
import KnowledgeCenter from './pages/KnowledgeCenter/KnowledgeCenter.js';
import Offmarket from './pages/Offmarket/index.js';
import Frequently from './pages/Frequently/index.js';
import CardViewMore from './pages/MainPage/MainPageContent/CardViewMore.js';
import Disclaimer from './pages/Disclaimer/Disclaimer.js';
import Sebiguiude from './pages/Sebiguide/Sebiguide.js';
import Terms from './pages/TermsOfUse/Terms.js';
import Privacy from './pages/Privacy/Privacy.js';
import BankingAlert from './pages/BankingAlert/BankingAlert.js';
import TopSectors from './pages/TopSectors/TopSectors.js';
import SignUp from './pages/SignUp/SignUp.js';
import SignIn from './pages/SignUp/SignIn.js';
import UnlistShareCard from './pages/UnlistShareCard/UnlistShareCard.js';
import { useState } from 'react';
import { imageApi } from "./components/Api/Api.jsx"
import FundRaise from "./pages/NewPages/FundRaise.js";
import SMELoans from "./pages/NewPages/SMELoans.js";
import BuySell from "./pages/NewPages/BuySell.js";
import PEInvestor from './pages/NewPages/PEInvestor.js';
import StartUp from "./pages/PEInvestorPage/StartUp.js";
import Business from "./pages/PEInvestorPage/Business.js";
import EarlyBusiness from "./pages/PEInvestorPage/EarlyBusiness.js";
import Debentures from "./pages/PEInvestorPage/Debentures.js";
import ProjectInvestment from './pages/PEInvestorPage/ProjectInvestment.js';
import Shark from './pages/shark/Shark.jsx';
import SharkForm from './pages/shark/SharkForm.jsx';
import PitchBusiness from './pages/BeAShark/PitchBusiness.tsx';
import SharkThankYou from './pages/shark/ThankYou.jsx';
import NewBlogs from './pages/newblogs/NewBlogs.jsx';
import BlogDetails from './pages/newblogs/BlogDetails.jsx';
import PartnerProgram from './pages/Partner Program/PartnerProgram';
import Roadmap from './pages/Roadmap/Roadmap';
import ThankYou from './pages/Thankyou/Thankyou';

// aqt-v2 pages
import V2Home from './pages/v2/Home.jsx';
import V2About from './pages/v2/About.jsx';
import V2Businesses from './pages/v2/Businesses.jsx';
import V2AFO from './pages/v2/AFO.jsx';
import V2Sectors from './pages/v2/Sectors.jsx';
import V2Partners from './pages/v2/Partners.jsx';
import V2Investors from './pages/v2/Investors.jsx';
import V2Insights from './pages/v2/Insights.jsx';
import V2Contact from './pages/v2/Contact.jsx';
import V2Legal from './pages/v2/Legal.jsx';
import V2ListingRoom from './pages/v2/ListingRoom.jsx';

function App() {
  const [head, setHead] = useState("")
  const [ids, setIds] = useState("")
  const [imgs, setImgs] = useState("")

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* ── AQT Landing pages ── */}
        <Route path={'/'} exact element={<MainPage headings={setHead} idpoly={setIds} images={setImgs} />} />
        <Route path={'/raisefunding'} exact element={<RaiseFunding />} />
        <Route path={'/fundraise'} exact element={<FundRaise />} />
        <Route path={'/smeloans'} exact element={<SMELoans />} />
        <Route path={'/buysell'} exact element={<BuySell />} />
        <Route path={'/peinvestor'} exact element={<PEInvestor />} />
        <Route path={'/business-opportunities'} exact element={<SellIPOShares />} />
        <Route path={'/limited-partnerships'} exact element={<Unlisted headings={setHead} idpoly={setIds} images={setImgs} />} />
        <Route path={'/media-coverage'} exact element={<MediaCoverage />} />
        <Route path={'/company'} exact element={<Polymatech heading={head} id={ids} img={imgs} />} />
        <Route path={'/blog'} exact element={<Blog />} />
        <Route path={'/knowledgecenter'} exact element={<KnowledgeCenter />} />
        <Route path={'/off-market'} exact element={<Offmarket />} />
        <Route path={'/frequently-asked-questions'} exact element={<Frequently />} />
        <Route path={'/companylist'} exact element={<CardViewMore headings={setHead} idpoly={setIds} />} />
        <Route path={'/disclaimer'} exact element={<Disclaimer />} />
        <Route path={'/sebiguidelines'} exact element={<Sebiguiude />} />
        <Route path={'/terms'} exact element={<Terms />} />
        <Route path={'/privacy'} exact element={<Privacy />} />
        <Route path={'/banking'} exact element={<BankingAlert />} />
        <Route path={'/topsectors'} exact element={<TopSectors />} />
        <Route path={'/unlistsharecard'} exact element={<UnlistShareCard />} />
        <Route path={'/startUp'} exact element={<StartUp />} />
        <Route path={'/business'} exact element={<Business />} />
        <Route path={'/earlyBusiness'} exact element={<EarlyBusiness />} />
        <Route path={'/debentures'} exact element={<Debentures />} />
        <Route path={'/projectInvestment'} exact element={<ProjectInvestment />} />
        <Route path={'/angel-investor'} exact element={<Shark />} />
        <Route path={'/angel-investor-form'} exact element={<SharkForm />} />
        <Route path={'/angel-investor-thank-you'} exact element={<SharkThankYou />} />
        <Route path={'/pitch-your-business'} exact element={<PitchBusiness />} />
        <Route path={'/roadmap'} exact element={<Roadmap />} />
        <Route path={'/partner-program'} exact element={<PartnerProgram />} />
        <Route path={'/thankyou'} exact element={<ThankYou />} />
        <Route path={'/blogs'} exact element={<NewBlogs />} />
        <Route path={'/blog-detail/:id'} exact element={<BlogDetails />} />

        {/* ── aqt-v2 pages ── */}
        <Route path={'/home'} exact element={<V2Home />} />
        <Route path={'/about'} exact element={<V2About />} />
        <Route path={'/businesses'} exact element={<V2Businesses />} />
        <Route path={'/afo'} exact element={<V2AFO />} />
        <Route path={'/sectors'} exact element={<V2Sectors />} />
        <Route path={'/partners'} exact element={<V2Partners />} />
        <Route path={'/investors'} exact element={<V2Investors />} />
        <Route path={'/insights'} exact element={<V2Insights />} />
        <Route path={'/contactus'} exact element={<V2Contact />} />
        <Route path={'/legal'} exact element={<V2Legal />} />
        <Route path={'/masterclass'} exact element={<V2ListingRoom />} />
      </Routes>
    </Router>
  );
}

export default App;
